<template>
    <div class="container" v-if="screenMode == 'ALBUM'">
        <div class="loading" v-if="loading">
            <loading type="spinner" color="#D21AD9" size="60px" vertical>
                <div>加载中...</div>
            </loading>
        </div>
        <div class="screen-box" v-if="screenShowType == 'AUTO_fill'">
            <img :src="url" class="bg-screen" />
            <img class="screen" :src="url"  style="object-fit: contain;"/>
        </div>
        <img class="screen" :src="url" style="object-fit: cover;" v-if="screenShowType == 'CROPPING'"/>
        <div class="passwordBox" v-if="privacy === 'VERIFIED' && !formMini && passwordPage">
            <div class="password">
                <input v-model="password" autofocus class="input" placeholder="请输入密码" />
            </div>
            <div class="passwordBtn" @click="checkPasseord">{{ screenButtonDesc }}</div>
        </div>

        <div v-if="!passwordPage && screenButton" class="joinBtn" :style="`bottom:${screenButtonHeight}px`" @click="join">{{ screenButtonDesc }}</div>

        <div v-if="privacy !== 'VERIFIED'" class="countDown">{{ time }}s</div>
    </div>
    <div class="container" v-if="screenMode == 'GATHER'">
        <div class="loading" v-if="loading">
            <loading type="spinner" color="#D21AD9" size="60px" vertical>
                <div>加载中...</div>
            </loading>
        </div>
        <!-- <div class="screen-box">
            <img class="bg-screen" :src="url"  />
            <img class="screen" :src="url" />
        </div> -->
        <img class="screen" :src="url" style="object-fit: cover;"/>
        <div class="passwordBox" v-if="privacy === 'VERIFIED' && !formMini && passwordPage">
            <div class="password-gather">
                <input v-model="password" autofocus class="input" placeholder="请输入密码" />
            </div>
            <div class="passwordBtn-gather" @click="checkPasseord">进入相册集</div>
        </div>

        <div v-if="!passwordPage" class="joinBtn" :style="`bottom:${screenButtonHeight}px`" @click="join">进入相册集</div>

        <div v-if="privacy !== 'VERIFIED'" class="countDown">{{ time }}s</div>
    </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, onUnmounted, reactive, toRefs} from 'vue'
import {Loading} from 'vant'
import {useCheckPassword, useCheckGatherPassword} from '@/views/api'
import {showNotify} from 'vant'
import {useAlbumStore} from '@/store/album'
export default defineComponent({
    components: {Loading},
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        url: {
            type: String,
            value: ''
        },
        privacy: {
            type: String,
            value: ''
        },
        albumId: {
            type: String,
            value: ''
        },
        screenMode: {
            type: String,
            default: 'ALBUM'
        },
        gatherId: {
            type: String,
            value: ''
        },
        countdown: {
            type: Number,
            default: 5
        },
        screenButtonDesc: {
            type: String,
            default: '进入相册'
        },
        screenButton: {
            type: Boolean,
            value: true
        },
        screenButtonPosition: {
            type: String,
            default: 'LOW'
        },
        screenShowType: {
            type: String,
            default: 'CROPPING'
        }
    },
    emits: ['join','forceRoute'],
    setup(props, context) {
        const albumStore = useAlbumStore()
        let interval
        const state = reactive({
            time: props.countdown,
            privacy: props.privacy,
            password: '',
            formMini: albumStore.formMini,
            passwordPage: false,
            screenButtonHeight: 96
        })
        onMounted(() => {
            if (props.privacy !== 'VERIFIED') {
                interval = setInterval(() => {
                    if (state.time > 0) {
                        state.time--
                    }
                    if (state.time === 0) {
                        context.emit('join')
                    }
                }, 1000)
            }
            computedScreenButtonHeight()
            console.log('开屏密码参数===》', state.privacy, state.formMini, state.passwordPage)
        })
        const computedScreenButtonHeight = () => {
            let height = 0
            if (props.screenButtonPosition === 'LOW') {
                height = 96
            } else if (props.screenButtonPosition === 'MEDIUM') {
                height = 208
            } else if (props.screenButtonPosition === 'TALL') {
                height = 320
            } else {
                height = 96
            }
            state.screenButtonHeight = height
        }
        onUnmounted(() => {
            clearInterval(interval)
        })

        const join = () => {
            // context.emit('join')
            if (props.privacy !== 'VERIFIED' || state.formMini) {
                context.emit('join')
            } else {
                state.passwordPage = true
            }
        }
        const checkPasseord = () => {
            if (props.screenMode === 'ALBUM') {
                useCheckPassword({albumId: props.albumId, password: state.password}).then(res => {
                    if (res) {
                        context.emit('join')
                        console.log('密码正确')
                        context.emit('forceRoute',props.privacy)
                    } else {
                        showNotify({type: 'danger', message: '密码错误'})
                    }
                })
            } else if (props.screenMode === 'GATHER') {
                useCheckGatherPassword({gatherId: props.gatherId, password: state.password}).then(res => {
                    if (res) {
                        context.emit('join')
                    } else {
                        showNotify({type: 'danger', message: '密码错误'})
                    }
                })
            }
        }
        return {
            ...toRefs(state),
            join,
            checkPasseord
        }
    }
})
</script>

<style scoped>
.container {
    width: 100%;
    max-width: 750px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    background: #fff;
    transform: translate(-50%);
    z-index: 999;
}

.screen {
    width: 100%;
    height: 100.2vh;
    position: relative;
    left: 0;
    top: 0;
    bottom: 0;
    animation: imgAnimation 1s;
}

.loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.passwordBox {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);
}

@keyframes animation {
    0% {
        bottom: -100px;
    }

    100% {
        bottom: 50px;
    }
}

@keyframes imgAnimation {
    0% {
        scale: 1.2;
    }

    100% {
        scale: 1;
    }
}

.joinBtn-gather {
    font-size: 20px;
    height: 48px;
    width: 235px;
    max-width: 600px;
    border-radius: 48px;
    color: #fff;
    font-size: 16px;
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.countDown-gather {
    font-size: 10px;
    width: 48px;
    height: 26px;
    color: #fff;
    border-radius: 13px;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 10px;
    top: 10px;
}

.input {
    border: none;
    width: 80%;
}

.joinBtn {
    font-size: 20px;
    height: 48px;
    width: 235px;
    max-width: 600px;
    border-radius: 48px;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 250px;
    left: 50%;
    transform: translate(-50%);
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid #fff;
}

.passwordBtn-gather {
    font-size: 16px;
    height: 48px;
    width: 235px;
    max-width: 600px;
    border-radius: 48px;
    color: #fff;
    font-size: 16px;
    background: #f6546f;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}

.password-gather {
    font-size: 14px;
    height: 50px;
    width: 235px;
    max-width: 600px;
    border-radius: 25px;
    color: #000;
    background: #fff;
    border: 1px solid #f6546f;
    display: flex;
    align-items: center;
    justify-content: center;
}
.screen-box {
    position: relative;
}
.bg-screen {
    filter: blur(10rpx);
    width: 100%;
    max-width: 750px;
    height: 100.2vh;
    object-fit: cover;
    filter: blur(10px);
    position: absolute;
    top: 0;
    left: 0;
}
</style>
